module.exports = __webpack_public_path__ + "img/xiaodang_yanxuan.baed7576.png";